export default __webpack_public_path__ + "static/media/food.31a857a8.png";